import { ServiceHandler } from '../utils';
import type { StaffAvatarList } from '../utils/avatarUrl';

const getStaffAvatarManifestHandler = ServiceHandler<
  undefined,
  StaffAvatarList
>({
  url: '/api/auth/v1/users/avatars',
});

/** The environment's photo folder, and encoded avatar key -> photo version for every Cowbell employee who has a photo. */
export function getStaffAvatarManifest(): Promise<StaffAvatarList> {
  return getStaffAvatarManifestHandler().then((response) => response.data);
}
